import { render } from "./FutureMiners.vue?vue&type=template&id=66dc09a0"
import script from "./FutureMiners.vue?vue&type=script&lang=js"
export * from "./FutureMiners.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__